<template>
<div class="quesbox">
  <L1>
    <template slot="slot_title">
      <Select :width="'210px'" :defaultValue="category" @input="category=$event">
        <option :value="null">所有類別</option>
        <option v-for="(rest, r) in restaurants" :value="rest" :key="`rest-${r}`">{{rest}}</option>
        <option value="限定活動">限定活動</option>
      </Select>
      <Select :width="'170px'" :defaultValue="status" @input="status=$event">
        <option :value="null">所有狀態</option>
        <option value="成立">成立</option>
        <option value="草稿">草稿</option>
      </Select>
      <SearchInput :defaultValue="searchText" @input="searchText=$event"/>
      <RoundBtn @click="$router.push({ name: 'questionnairenew' })" :style="{marginLeft: 'auto'}" :icon="'add'" :text="'新增表單'" :bg="'var(--color-checked)'"/>
    </template>
    <Table :rows="rows" :style="{marginInline: '18px 23px'}">
      <template slot="slot_head">
        <th :style="{textAlign: 'start', width: '145px'}">表單類別</th>
        <th :style="{textAlign: 'start', width: '550px'}">表單名稱</th>
        <th :style="{width: '100px'}">表單圖片</th>
        <th :style="{width: '80px'}">狀態</th>
        <th :style="{textAlign: 'start', width: '180px'}">開放期間</th>
        <th :style="{width: '100px'}">表單開放</th>
        <th :style="{width: '100px'}">表單連結</th>
        <th :style="{width: '80px'}">回覆</th>
        <th :style="{width: '100px'}">編輯表單</th>
        <th :style="{width: '80px'}">刪除</th>
        <th :style="{textAlign: 'start', width: '145px'}">新增時間</th>
        <th :style="{width: '80px'}">複製</th>
      </template>
      <tr @click="selected=selected?._id!==item.item._id?item.item:null" slot-scope="item" :style="{height: '100px', borderBottom: '1px solid #cacaca'}">
        <td :style="{textAlign: 'start'}"><div class="status" :class="item.item?.category">{{item.item?.category}}</div></td>
        <td :style="{textAlign: 'start'}">{{item.item?.name}}</td>
        <td><div class="imgtd" v-if="item.item?.image" :style="{backgroundImage: `url(${dev?'https://demo-cmcp1885.siotek.dev'+item.item.image:item.item?.image})`}"></div></td>
        <td :style="{textAlign: 'start', color: item.item.status==='成立'?'#E37878':'#848484'}">{{item.item.status}}</td>
        <td :style="{textAlign: 'start'}">
          <span v-if="item.item.mode==='unset'">不限時間</span>
          <span v-else>起 {{toDate(item.item.startTime)}}<br>迄 {{toDate(item.item.expireTime)}}</span>
        </td>
        <td><SwitchInput :defaultValue="item.item.active" @update="updateOne(item.item._id, $event, 'active', item.index)"/></td>
        <td><button class="tdbtn link">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M29.9796 22.4671C29.8862 20.4595 29.0272 18.5636 27.5793 17.1696L25.1787 14.7689C24.6949 14.2616 23.9736 14.0561 23.2949 14.2323C22.6162 14.4085 22.0862 14.9385 21.91 15.6172C21.7338 16.296 21.9393 17.0168 22.4466 17.501L24.8472 19.9017C25.6014 20.6159 26.0468 21.5961 26.0897 22.6338C26.142 23.5517 25.8124 24.4505 25.1791 25.1168C24.5604 25.72 23.7249 26.0482 22.8612 26.0274C21.7785 25.9717 20.7511 25.531 19.9643 24.7853L13.9207 18.7416C12.4292 17.4076 12.2815 15.1242 13.5892 13.6093C14.0968 13.1254 14.302 12.4042 14.1258 11.7255C13.9496 11.0468 13.4196 10.5168 12.7409 10.3406C12.0621 10.1644 11.3413 10.3699 10.8571 10.8772C9.50659 12.2072 8.759 14.032 8.78831 15.9271C8.81651 18.0461 9.6791 20.0687 11.1889 21.5561L17.2315 27.5994C18.7223 29.1038 20.7427 29.9656 22.8605 29.9997C24.7516 30.0059 26.5677 29.262 27.9104 27.9306C29.373 26.5043 30.1301 24.5044 29.9796 22.4671Z" fill="#517FA4"/>
        <path d="M7.70044 12.4947L5.22181 10.016C4.47935 9.31827 4.00978 8.37912 3.89696 7.36635C3.84422 6.44844 4.17387 5.54958 4.80754 4.88332C5.42619 4.28005 6.26168 3.95186 7.12574 3.97274C8.2169 3.99032 9.25751 4.43645 10.0227 5.2148L16.0656 11.2581C17.5571 12.5925 17.7047 14.8755 16.3971 16.3904C15.8894 16.8743 15.6843 17.5955 15.8605 18.2742C16.0367 18.953 16.5667 19.483 17.2454 19.6592C17.9241 19.8353 18.645 19.6299 19.1292 19.1225C20.4797 17.7922 21.2273 15.9678 21.1979 14.0726C21.1697 11.9533 20.3072 9.93069 18.7977 8.44358L12.7548 2.40065C11.2636 0.895966 9.24322 0.0344693 7.12574 3.87583e-05C5.23463 -0.00618804 3.4186 0.738098 2.07581 2.06917C0.670013 3.49804 -0.0794007 5.44629 0.0066757 7.44913C0.100078 9.45709 0.95901 11.3526 2.40692 12.7467L3.23509 13.5748L4.80754 15.2253C5.56611 15.9696 6.78107 15.9696 7.53964 15.2253C7.93633 14.8927 8.1788 14.4114 8.20994 13.8946C8.24107 13.3778 8.0583 12.8708 7.70447 12.4928L7.70044 12.4947Z" fill="#517FA4"/>
        </svg>
        </button></td>
        <td></td>
        <td><button  @click.stop="$router.push({ name: 'questionnaireEdit', params: { id: item.item._id } })" class="tdbtn edit">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24.2578 14.8996L18.8504 25.7746L19.1819 29.9263L22.6875 27.6797L28.0915 16.808L24.2578 14.8996ZM26.1629 11.0625L24.8906 13.6205L28.7277 15.529L30 12.971L26.1629 11.0625ZM3.21429 27.8571C2.62165 27.8571 2.14286 27.3783 2.14286 26.7857V3.21429C2.14286 2.62165 2.62165 2.14286 3.21429 2.14286H21.3984C21.9911 2.14286 22.4699 2.62165 22.4699 3.21429V11.7857C22.4699 12.3783 22.9487 12.8571 23.5413 12.8571C24.1339 12.8571 24.6127 12.3783 24.6127 11.7857V2.14286C24.6127 0.960938 23.6518 0 22.4699 0H2.14286C0.957589 0 0 0.960938 0 2.14286V27.8571C0 29.0391 0.960938 30 2.14286 30H16.0915C16.6842 30 17.1629 29.5212 17.1629 28.9286C17.1629 28.3359 16.6842 27.8571 16.0915 27.8571H3.21429Z" fill="#CCA16E"/>
        <path d="M18.7198 6.39502H5.85933C5.2667 6.39502 4.7879 6.87381 4.7879 7.46645C4.7879 8.05908 5.2667 8.53788 5.85933 8.53788H18.7198C19.3125 8.53788 19.7913 8.05908 19.7913 7.46645C19.7946 6.87381 19.3125 6.39502 18.7198 6.39502ZM18.7198 12.8236H5.85933C5.2667 12.8236 4.7879 13.3024 4.7879 13.895C4.7879 14.4877 5.2667 14.9664 5.85933 14.9664H18.7198C19.3125 14.9664 19.7913 14.4877 19.7913 13.895C19.7946 13.3024 19.3125 12.8236 18.7198 12.8236ZM12.2913 19.2522H5.85933C5.2667 19.2522 4.7879 19.731 4.7879 20.3236C4.7879 20.9162 5.2667 21.395 5.85933 21.395H12.2913C12.8839 21.395 13.3627 20.9162 13.3627 20.3236C13.3627 19.731 12.8839 19.2522 12.2913 19.2522Z" fill="#CCA16E"/>
        </svg>
        </button></td>
        <td><button @click.stop="deleteOne(item.item._id, item.index)" class="tdbtn del">
          <svg width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.4239 12.8205V20.3555C15.4239 20.9882 15.9367 21.501 16.5694 21.501C17.2021 21.501 17.7149 20.9882 17.7149 20.3555V12.8205C17.7149 12.1878 17.2021 11.675 16.5694 11.675C15.9367 11.6755 15.4239 12.1883 15.4239 12.8205ZM8.55112 12.8205V20.3555C8.55112 20.9882 9.06434 21.501 9.69659 21.501C10.3288 21.501 10.8421 20.9882 10.8421 20.3555V12.8205C10.8421 12.1878 10.3293 11.675 9.69659 11.675C9.06389 11.675 8.55112 12.1883 8.55112 12.8205Z" fill="#E37878"/>
          <path d="M7.81596 5.85548L7.49738 3.58736L16.5716 2.31124L16.8911 4.5807L7.81596 5.85548ZM23.6954 3.62405L19.1592 4.26122L18.7341 1.2396C18.6849 0.892831 18.4988 0.580512 18.2173 0.372449C17.6298 -0.070972 16.7399 -0.0239899 16.2575 0.0426798L7.17209 1.3197C5.50445 1.55461 5.01852 2.41818 5.12188 3.14797L5.54561 6.17451L1.00939 6.81212C0.597287 6.86134 0.244251 7.12981 0.086302 7.51327C-0.0716471 7.89673 -0.00989932 8.33613 0.247831 8.66142C0.506008 8.98672 0.91945 9.1469 1.32886 9.08023L2.97279 8.85025C2.87838 9.01356 2.82692 9.19791 2.82289 9.38629V25.4206C2.82289 26.6851 3.85023 27.7129 5.11383 27.7129H21.1495C22.4144 27.7111 23.4391 26.6855 23.4404 25.4206V9.38584C23.4404 8.75315 22.9276 8.24037 22.2949 8.24037C21.6622 8.24037 21.1495 8.7536 21.1495 9.38584V25.4215L5.11293 25.4201V9.38584C5.11248 9.09008 4.99704 8.8064 4.79077 8.59431L24.0149 5.89217C24.6413 5.80357 25.0772 5.22413 24.9886 4.5977C24.9492 4.29567 24.7895 4.02183 24.546 3.83838C24.3022 3.65537 23.9952 3.57797 23.6941 3.62361H23.6954V3.62405Z" fill="#E37878"/>
          </svg>
          </button></td>
        <td :style="{textAlign: 'start'}">{{toDate(item.item.createTime)}}</td>
        <td><button @click.stop="clone(item.item)" class="tdbtn del">
          <svg width="26" height="30" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_410_640)">
          <mask id="mask0_410_640" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="26" height="30">
          <path d="M25.8612 0H0.00421143V30H25.8612V0Z" fill="white"/>
          </mask>
          <g mask="url(#mask0_410_640)">
          <path d="M17.9424 5.70867C18.5135 5.70867 19.061 5.93393 19.4647 6.33556C19.8684 6.73676 20.0955 7.28089 20.0955 7.84843V27.8196C20.0955 29.0015 19.1316 29.9593 17.9424 29.9593H2.15307C1.582 29.9593 1.03448 29.7337 0.630782 29.3325C0.227082 28.9313 0 28.3867 0 27.8196V7.84843C0 6.66655 0.963835 5.70867 2.15307 5.70867H17.9424ZM17.2246 8.56182H2.8709V27.1062H17.2246V8.56182ZM23.6779 0.00280824C24.7876 0.0019724 25.7157 0.839485 25.8225 1.93736L25.8309 2.14256V21.3903C25.8301 22.1451 25.238 22.7686 24.4798 22.8125C23.7216 22.8568 23.0601 22.3064 22.9701 21.5571L22.96 21.3903V2.85595H8.61228C7.88478 2.85595 7.27208 2.31474 7.18671 1.59634L7.17662 1.42959C7.17662 0.706586 7.72119 0.0976762 8.44407 0.0128383L8.61228 0.00280824H23.6779Z" fill="#517FA4"/>
          </g>
          </g>
          <defs>
          <clipPath id="clip0_410_640">
          <rect width="25.8621" height="30" fill="white"/>
          </clipPath>
          </defs>
          </svg>
          </button></td>
      </tr>
    </Table>
  </L1>
  <InfoSliderVue :style="{zIndex: '99', width: '400px'}" :show="selected" :label="'問券預覽'" @close="selected=null">
    <template  v-if="selected">
    <Card :style="{padding: '34px 0 18px 0' , gap: '0'}" class="info">
      <div :style="{paddingInline: '28px', width: '100%'}">
        <img v-if="selected.image" :src="dev?'https://demo-cmcp1885.siotek.dev'+selected.image:selected.image"
        :style="{marginBottom: '30px', width: 'calc(100% - 20px)', marginInline: '10px'}">
        <div class="name1">{{selected.name}}</div>
        <p class="description1">{{selected.description}}</p>
      </div>
      <hr>
      <div class="notice">*表示必填問題</div>
    </Card>
    <Card class="mobileQues" :style="{gap: '11px', padding: '25px'}"
      v-for="(ques, q) in selected.questions" :key="`mobile-q-${q}`">
      <div class="questitle">{{ques.question||'未命名的問題'}}<span v-if="ques.required" class="required">*</span></div>
      <template v-if="ques.mode==='date'" >
        <DateInput :style="{marginRight: 'auto', marginLeft: '0'}" :defaultValue="ques.single" @input="ques.single=$event"/>
      </template>
      <template v-if="ques.mode==='time'" >
        <TimeInput v-eles-if="ques.mode==='time'" :style="{marginRight: 'auto', marginLeft: '0'}" :defaultValue="ques.single" @input="ques.single=$event"/>
      </template>
      <template v-if="ques.mode==='select'" >
        <Select :width="'315px'" v-eles-if="ques.mode==='select'" :defaultValue="ques.single" @input="ques.single=$event">
          <option :value="null">選擇</option>
          <option v-for="(ans, a) in ques.answers" :key="`${ques.mode}-${q}-${a}`" value="ans">{{ans}}</option>
        </Select>
      </template>
      <template v-else-if="ques.mode==='radio'">
        <label v-for="(ans, a) in ques.answers" :key="`${ques.mode}-${q}-${a}`" :for="`${ques.mode}-${q}-${a}`">
          <input :type="ques.mode" :value="ans"  v-model="ques.single" :id="`${ques.mode}-${q}-${a}`">
          {{ans}}
        </label>
      </template>
      <template v-else-if="ques.mode==='checkbox'">
        <label v-for="(ans, a) in ques.answers" :key="`${ques.mode}-${q}-${a}`" :for="`${ques.mode}-${q}-${a}`">
          <input :type="ques.mode" :value="ans"  v-model="ques.multi" :id="`${ques.mode}-${q}-${a}`">
          {{ans}}
        </label>
      </template>
      <template v-else-if="ques.mode==='other'">
        <textarea v-model="ques.single"></textarea>
      </template>
    </Card>
    </template>
  </InfoSliderVue>
  </div>
</template>

<script>
import DateInput from '../../components/input/date.vue'
import TimeInput from '../../components/input/time.vue'
import Card from '../../components/layout/card.vue'
import InfoSliderVue from '../../components/infoSlider.vue'
import SwitchInput from '../../components/radio/switch.vue'
import RoundBtn from '../../components/btn/round.vue'
import Table from '../../components/tables/t2.vue'
import SearchInput from '../../components/input/search.vue'
import Select from '../../components/select.vue'
import L1 from '../../components/layout/L1.vue'
import { getapi, postapi, deleteapi, putapi } from '../../store/fetch'
import { mapState } from 'vuex'
export default {
  components: {
    L1,
    Select,
    SearchInput,
    Table,
    RoundBtn,
    SwitchInput,
    InfoSliderVue,
    DateInput,
    TimeInput,
    Card
  },
  data () {
    return {
      selected: null,
      category: null,
      status: null,
      searchText: null,
      rows: []
    }
  },
  computed: {
    dev () {
      return /localhost/ig.test(location.host)
    },
    ...mapState({
      restaurants: 'restaurants'
    })
  },
  watch: {
    category () { this.getdata() },
    status () { this.getdata() },
    searchText () { this.getdata() }
  },
  async mounted () {
    await this.getdata()
  },
  methods: {
    async clone (value) {
      const data = JSON.parse(JSON.stringify(value))
      delete data._id
      delete data.createBy
      delete data.createTime
      delete data.updateTime
      delete data.operator
      delete data.activeBy
      data.questions = data.questions.map(e => {
        delete e._id
        return e
      })
      const r = await putapi('questionnaire', data)
      if (r) {
        this.getdata()
      }
    },
    async deleteOne (id, index) {
      const r = await deleteapi(`questionnaire/${id}`)
      if (r) {
        this.rows.splice(index, 1)
      }
    },
    async updateOne (id, value, key, index) {
      const r = await postapi(`questionnaire/${id}`, { [key]: value })
      if (r) {
        this.rows[index] = r
      }
    },
    async getdata () {
      const params = {}
      if (this.category) params.category = this.category
      if (this.status) params.status = this.status
      if (this.searchText) params.search = this.searchText
      this.rows = await getapi('questionnaire?' + new URLSearchParams(params))
    }
  }
}
</script>
<style lang="scss">
.quesbox {
  * {
    box-sizing: border-box;
  }
  .infobox >div:not(.headerBox) {
    width: 99%;
  }
  .mobileQues {
    #setDate-wrapper, #setDate-input {
      width: 315px;
    }
    #setTime-wrapper, #setTime-input {
      width: 240px;
    }
    textarea {
      width: 100%;
      border: 1px solid #CACACA;
      border-radius: 3px;
      min-height: 85px;
    }
    #setDate-wrapper > .field > input[type=text] {
      border: 1px solid #848484!important;
      font-weight: 400;
      font-size: 16px!important;
      line-height: 170%;
      letter-spacing: 0.1em;
      &::placeholder{
        color: #848484;
        font-weight: 400;
        font-size: 16px!important;
        line-height: 170%;
        letter-spacing: 0.1em;
      }
    }
    #setTime-wrapper > .field > input[type=text] {
      border: 1px solid #848484!important;
      font-weight: 400;
      font-size: 16px!important;
      line-height: 170%;
      letter-spacing: 0.1em;
      &::placeholder{
        color: #848484;
        font-weight: 400;
        font-size: 16px!important;
        line-height: 170%;
        letter-spacing: 0.1em;
      }
    }
    #setDateRange-input, #setDate-input, #setTime-input {
      border: none;
    }
    #setDateRange-wrapper > .field::after {
      background-color: #848484;
      mask-image: url(/svg/icon/celender1.svg);
      mask-repeat: no-repeat;
    }
    #setDate-wrapper > .field::after {
      background-color: #848484;
      mask-image: url(/svg/icon/celender1.svg);
      mask-repeat: no-repeat;
    }
    #setTime-wrapper > .field::after {
      background-color: #848484;
    }
  }
  .word4icon {
    background-image: url(/questionnaireWhite.svg);
    background-size: 36px;
    background-position: 18px 15px;
  }
}
</style>
<style lang="scss" scoped>
.mobileQues {
  display: flex!important;
  flex-direction: column;
  align-items: flex-start;
  gap: 11px;
  .questitle {
    font-weight: 400;
    font-size: 16px;
    line-height: 170%;
    letter-spacing: 0.1em;
    color: #5E5E5E;
  }
  .required {
    color: #E37878;
    margin-left: .25em;
  }
}
.info {
  hr {
    width: 100%;
    height: 1px;
    border: none;
    background-color: #C4C4C4;
    margin-block: 18px 11px;
  }
  .notice {
    font-weight: 400;
    font-size: 16px;
    line-height: 170%;
    letter-spacing: 0.1em;
    color: #E37878;
    padding-inline: 31px 22px;
    text-align: start;
  }
}
.name1 {
  font-weight: 500;
  font-size: 28px;
  line-height: 41px;
  letter-spacing: 0.1em;
  color: #5E5E5E;
  width: 100%;
  text-align: center;
}
.description1 {
  margin-top: 11px;
  font-weight: 400;
  font-size: 16px;
  line-height: 170%;
  letter-spacing: 0.1em;
  color: #848484;
  width: 100%;
  text-align: start;
}
.status {
  width: 125px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  border-radius: 20px;
  background: #E37878;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: 0.1em;
  &.成美文化園 {background: #517FA4;}
  &.松柏軒餐廳 {background: #CCA16E;}
}
.imgtd {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 100px;
  height: 75px;
}
.tdbtn {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-inline: auto;
  background-color: transparent;
}
.subtitle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  background-color: var(--color-infobox);
  color: var(--color-checked);
  font-weight: 400;
  font-size: 20px;
  line-height: 29px;
}
</style>
